export default {
  userId: null,
  userData: null,
}
